
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30619',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30619",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55086",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8207",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11658",
  "I18n": "static-7.1646",
  "quartz": "static-1.7276",
  "quartz-config": "static-1.1054",
  "quartz-core": "static-1.6495",
  "react-dlb": "static-1.83",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.844",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55073",
  "feedback-utils": "static-1.55077",
  "forms-embed-utils-lib": "static-1.4649",
  "forms-utils-lib": "static-1.12919",
  "foundations-assets": "static-1.5057",
  "foundations-components": "static-1.8286",
  "foundations-theming": "static-1.4621",
  "hub-http": "static-1.6402",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11965",
  "icons": "static-2.666",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4047",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16887",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5470",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.491",
  "tinymce-plugins": "static-1.57976",
  "transmute": "static-2.85",
  "ui-images": "static-2.1207",
  "UIComponents": "static-3.8604",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3530",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3553",
  "quartz-webpack": "static-1.3500",
  "foundations-theming-specialty": "static-1.2337",
  "property-description-translator": "static-1.4021",
  "HeadJS": "static-2.778",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3318",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4506",
  "jasmine-runner": "static-1.6639",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.853",
  "hubspotter-http": "static-1.4780",
  "mobile-manifest-mixins": "static-1.552",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.951",
  "quartz-head": "static-1.941",
  "quartz-i18n": "static-1.951",
  "quartz-routing": "static-1.706",
  "quartz-test": "static-1.951",
  "quartz-tracking": "static-1.655",
  "trellis-components": "static-1.2318",
  "ui-fonts": "static-1.920",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.3",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.3",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7431",
  "reference-resolvers": "static-1.8360",
  "sanitize-text": "static-1.8329",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10548",
  "sanitize": "static-1.4660",
  "outpost": "static-1.4350",
  "rpc-client-utils": "static-1.4841",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4555",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9610",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.46",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2299",
  "bend-plugin-foundations-theming": "static-1.3104",
  "foundations-theming-base": "static-1.3606",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.210",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9427",
  "atom": "static-1.5260",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8033",
  "ContentUtils": "static-1.68909",
  "data-token-picker": "static-1.16728",
  "file-manager-components": "static-1.24166",
  "FileManagerCore": "static-1.39665",
  "FileManagerLib": "static-1.39806",
  "frontend-preferences-client": "static-1.8110",
  "hub-http-contrib": "static-1.3226",
  "interframe": "static-3.4940",
  "layout-dnd-components": "static-1.12797",
  "layout-dnd-utils": "static-1.11772",
  "property-translator": "static-1.5577",
  "react-codemirror": "static-1.10818",
  "react-colorpicker": "static-2.10392",
  "reference-resolvers-lite": "static-1.8282",
  "rich-text-lib": "static-1.20148",
  "tinymce-data": "static-1.40947",
  "tinymce-themes": "static-1.56832",
  "ui-addon-emoji-picker": "static-1.10068",
  "ui-addon-sales-email": "static-1.5396",
  "ui-brand-identity-lib": "static-1.15969",
  "bender-build-tools": "static-1.3316",
  "hub-http-shared-msw-handlers": "static-1.10412",
  "hubspotter-http-shared-msw-handlers": "static-1.10410",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.3",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1131",
  "tanstack-virtual": "static-1.33",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.251",
  "chirp-fetch": "static-1.2071",
  "chatspot-core": "static-1.22247",
  "copilot-toolkit": "static-1.11611",
  "customer-data-objects-ui-components": "static-1.13214",
  "data-fetching-client": "static-1.9842",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4941",
  "ui-addon-video-player": "static-1.8892",
  "ui-coaching-tips": "static-1.29078",
  "usage-tracker": "static-1-session-replay-endpoint-migration.3",
  "cms-field-types": "static-1.5000",
  "content-icons-ui": "static-1.2280",
  "integrations-lib": "static-1.16741",
  "customer-data-objects": "static-1.7864",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1377",
  "apollo-link-hub-http": "static-2.4837",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.33",
  "immerable": "static-1.4331",
  "ui-addon-iframeable": "static-1.9259",
  "video-components-external": "static-1.11882",
  "video-data-lib": "static-1.35540",
  "audio-components": "static-1.6188",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29637",
  "FileManagerImages": "static-1.37317",
  "foundations-components-legacy": "static-1.1311",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.529",
  "ui-universal-auth": "static-1.9195",
  "urlinator": "static-1.4715",
  "video-components": "static-1.13884",
  "video-embed": "static-1.36374",
  "ts-schema": "static-1.4209",
  "ContentData": "static-1.68984",
  "layout-data-lib": "static-1.10097",
  "react-dnd-compat": "static-1.4797",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1729",
  "external-options-client-types": "static-1.4255",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7078",
  "hs-promise-utils": "static-1.5776",
  "inbound-db-properties-service-client": "static-1.3975",
  "NamespacedHubStyle": "static-2.9180",
  "growth-onboarding-confetti": "static-1.3245",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11332",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5677",
  "magpie-types": "static-1.5137",
  "simple-logging-lib": "static-1.3233",
  "avatar-components": "static-1.2683",
  "customer-data-ui-utilities": "static-1.10009",
  "growth-onboarding-feedback-components": "static-1.6764",
  "flux-actions": "static-1.353",
  "hubspot-apollo-client": "static-1.5060",
  "integrations-error-boundary-lib": "static-1.14156",
  "integrations-tracking-lib": "static-1.5791",
  "laboratory-lib": "static-3.7335",
  "native-integrations-shared-strings": "static-1.7963",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10446",
  "unified-auth": "static-1.709",
  "breeze-engine-core": "static-1.655",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.7854",
  "content-media-composition-data-lib": "static-1.12915",
  "content-media-compositions": "static-2.16922",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19245",
  "unified-auth-core-lib": "static-1.991",
  "social-insights-client-types": "static-1.22564",
  "advanced-menus-core": "static-1.15430",
  "advanced-menus-lib": "static-1.12324",
  "ExportDialog": "static-6.10563",
  "ui-memberships-settings-lib": "static-1.34558",
  "conditional-properties-service-client": "static-1.3926",
  "crm-pipelines-api-client-types": "static-1.4267",
  "fdsr-migration-layer": "static-1.197",
  "framework-builder-read-service-client": "static-1.4135",
  "framework-data-schema-quick-fetch": "static-1.6983",
  "inbound-db-meta-service-client": "static-1.3717",
  "multi-currency-client-types": "static-1.3821",
  "persist-promise": "static-1.3886",
  "foundations-components-test-utils": "static-1.5769",
  "reactive-lib": "static-1.907",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.519",
  "universal-page-editor-lib": "static-1.3195",
  "adobe-sign-auth-lib": "static-1.220",
  "ads-unified-auth-lib": "static-1.717",
  "google-sheets-integration-lib": "static-1.788",
  "microsoft-drive-integration-lib": "static-1.893",
  "surveymonkey-integration-lib": "static-1.234",
  "slack-ui-library": "static-1.10581",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3914",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15429",
  "simple-menus-lib": "static-1.16946",
  "crm-record-cards-service-types": "static-1.3714",
  "location-customization-utils-lib": "static-1.9808",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30619",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55086",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8207",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11658",
  "I18n": "/I18n/static-7.1646",
  "quartz": "/quartz/static-1.7276",
  "quartz-config": "/quartz-config/static-1.1054",
  "quartz-core": "/quartz-core/static-1.6495",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.844",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55073",
  "feedback-utils": "/feedback-utils/static-1.55077",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4649",
  "forms-utils-lib": "/forms-utils-lib/static-1.12919",
  "foundations-assets": "/foundations-assets/static-1.5057",
  "foundations-components": "/foundations-components/static-1.8286",
  "foundations-theming": "/foundations-theming/static-1.4621",
  "hub-http": "/hub-http/static-1.6402",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11965",
  "icons": "/icons/static-2.666",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4047",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16887",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5470",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tinymce-plugins": "/tinymce-plugins/static-1.57976",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1207",
  "UIComponents": "/UIComponents/static-3.8604",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3530",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3553",
  "quartz-webpack": "/quartz-webpack/static-1.3500",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2337",
  "property-description-translator": "/property-description-translator/static-1.4021",
  "HeadJS": "/HeadJS/static-2.778",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3318",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4506",
  "jasmine-runner": "/jasmine-runner/static-1.6639",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.853",
  "hubspotter-http": "/hubspotter-http/static-1.4780",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.552",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.951",
  "quartz-head": "/quartz-head/static-1.941",
  "quartz-i18n": "/quartz-i18n/static-1.951",
  "quartz-routing": "/quartz-routing/static-1.706",
  "quartz-test": "/quartz-test/static-1.951",
  "quartz-tracking": "/quartz-tracking/static-1.655",
  "trellis-components": "/trellis-components/static-1.2318",
  "ui-fonts": "/ui-fonts/static-1.920",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.3",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.3",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7431",
  "reference-resolvers": "/reference-resolvers/static-1.8360",
  "sanitize-text": "/sanitize-text/static-1.8329",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10548",
  "sanitize": "/sanitize/static-1.4660",
  "outpost": "/outpost/static-1.4350",
  "rpc-client-utils": "/rpc-client-utils/static-1.4841",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4555",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9610",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.46",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2299",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3104",
  "foundations-theming-base": "/foundations-theming-base/static-1.3606",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.210",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9427",
  "atom": "/atom/static-1.5260",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8033",
  "ContentUtils": "/ContentUtils/static-1.68909",
  "data-token-picker": "/data-token-picker/static-1.16728",
  "file-manager-components": "/file-manager-components/static-1.24166",
  "FileManagerCore": "/FileManagerCore/static-1.39665",
  "FileManagerLib": "/FileManagerLib/static-1.39806",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8110",
  "hub-http-contrib": "/hub-http-contrib/static-1.3226",
  "interframe": "/interframe/static-3.4940",
  "layout-dnd-components": "/layout-dnd-components/static-1.12797",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11772",
  "property-translator": "/property-translator/static-1.5577",
  "react-codemirror": "/react-codemirror/static-1.10818",
  "react-colorpicker": "/react-colorpicker/static-2.10392",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8282",
  "rich-text-lib": "/rich-text-lib/static-1.20148",
  "tinymce-data": "/tinymce-data/static-1.40947",
  "tinymce-themes": "/tinymce-themes/static-1.56832",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10068",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5396",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15969",
  "bender-build-tools": "/bender-build-tools/static-1.3316",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10412",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10410",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.3",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1131",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.251",
  "chirp-fetch": "/chirp-fetch/static-1.2071",
  "chatspot-core": "/chatspot-core/static-1.22247",
  "copilot-toolkit": "/copilot-toolkit/static-1.11611",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13214",
  "data-fetching-client": "/data-fetching-client/static-1.9842",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4941",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8892",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29078",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.3",
  "cms-field-types": "/cms-field-types/static-1.5000",
  "content-icons-ui": "/content-icons-ui/static-1.2280",
  "integrations-lib": "/integrations-lib/static-1.16741",
  "customer-data-objects": "/customer-data-objects/static-1.7864",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1377",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4837",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4331",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9259",
  "video-components-external": "/video-components-external/static-1.11882",
  "video-data-lib": "/video-data-lib/static-1.35540",
  "audio-components": "/audio-components/static-1.6188",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29637",
  "FileManagerImages": "/FileManagerImages/static-1.37317",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1311",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.529",
  "ui-universal-auth": "/ui-universal-auth/static-1.9195",
  "urlinator": "/urlinator/static-1.4715",
  "video-components": "/video-components/static-1.13884",
  "video-embed": "/video-embed/static-1.36374",
  "ts-schema": "/ts-schema/static-1.4209",
  "ContentData": "/ContentData/static-1.68984",
  "layout-data-lib": "/layout-data-lib/static-1.10097",
  "react-dnd-compat": "/react-dnd-compat/static-1.4797",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1729",
  "external-options-client-types": "/external-options-client-types/static-1.4255",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7078",
  "hs-promise-utils": "/hs-promise-utils/static-1.5776",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3975",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9180",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3245",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11332",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5677",
  "magpie-types": "/magpie-types/static-1.5137",
  "simple-logging-lib": "/simple-logging-lib/static-1.3233",
  "avatar-components": "/avatar-components/static-1.2683",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10009",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6764",
  "flux-actions": "/flux-actions/static-1.353",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5060",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14156",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5791",
  "laboratory-lib": "/laboratory-lib/static-3.7335",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7963",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10446",
  "unified-auth": "/unified-auth/static-1.709",
  "breeze-engine-core": "/breeze-engine-core/static-1.655",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.7854",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12915",
  "content-media-compositions": "/content-media-compositions/static-2.16922",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19245",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.991",
  "social-insights-client-types": "/social-insights-client-types/static-1.22564",
  "advanced-menus-core": "/advanced-menus-core/static-1.15430",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12324",
  "ExportDialog": "/ExportDialog/static-6.10563",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34558",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3926",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4267",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.197",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4135",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6983",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3717",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3821",
  "persist-promise": "/persist-promise/static-1.3886",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5769",
  "reactive-lib": "/reactive-lib/static-1.907",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.519",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3195",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.220",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.717",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.788",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.893",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.234",
  "slack-ui-library": "/slack-ui-library/static-1.10581",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3914",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15429",
  "simple-menus-lib": "/simple-menus-lib/static-1.16946",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3714",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9808",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
